export default __webpack_public_path__ + "static/media/user-03.680deb88.jpg";